import { Stack, StepConnector, stepConnectorClasses, StepLabel, styled } from '@mui/material'
import { MUIThemeColors } from 'src/mui-theme'
import { getThemeColor } from 'src/utils'

//styled
export const StepLabelStyled = styled(StepLabel)`
  .MuiStepLabel-iconContainer {
    padding-right: 0;
  }

  .MuiStepIcon-root {
    font-size: 16px !important;
    height: 44px;
    width: 44px;
    color: ${props => props.theme.palette.secondaryMain[props.theme.palette.mode]} !important;
    flex-shrink: 0;
  }
  .MuiStepIcon-root.Mui-active {
    color: ${props => props.theme.palette.primaryMain[props.theme.palette.mode]} !important;
  }
  .MuiStepIcon-root.Mui-completed {
    color: ${props => props.theme.palette.primaryMain[props.theme.palette.mode]} !important;
  }

  .MuiStepLabel-label {
    font-size: 16px !important;
    max-width: 160px;
    padding-left: 10px;
    line-height: 1.3;
  }
`

export const DetailContainer = styled(Stack)`
  background-color: ${props => getThemeColor(props.theme, MUIThemeColors.paleBlue)};
  padding: 5px;
  border-radius: 4px;
  opacity: 1;
  margin-left: 8px;
  margin-right: 8px;
`

export const CustomizedConnector = styled(StepConnector)(({ theme }) => ({
  flex: '1 1 auto',
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundColor: theme.palette.primaryMain[theme.palette.mode],
      height: '2px',
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundColor: theme.palette.primaryMain[theme.palette.mode],
      height: '2px',
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    height: '1px',
    border: 0,
    backgroundColor: theme.palette.secondaryMain[theme.palette.mode],
    borderRadius: 1,
    minWidth: 24,
  },
}))
